import metamask from "../../src/images/metamask.png";
import trustwallet from "../../src/images/trustwallet.png";
import safepal from "../../src/images/safe.jpeg";
import coinbase from "../../src/images/coinbase.png";
import keplr from "../../src/images/keplr.png";
import solana from "../../src/images/solana.png";
import blockchain from "../../src/images/blockchain.png";
import agent from "../../src/images/agent.jpg";
import bitpay from "../../src/images/bitpay.jpg";
import curve from "../../src/images/curve.png";
import edge from "../../src/images/edge.jpg";
import crypto from "../../src/images/crypto.jpg";
import im from "../../src/images/im.jpg";
import ledger from "../../src/images/ledger.jpg";
// import lobster from "../../src/images/lobster.jpg"
import maths from "../../src/images/maths.jpg";
import nosis from "../../src/images/nosis.jpg";
import onto from "../../src/images/onto.jpg";
import pillar from "../../src/images/pillar.jpg";
import rainbow from "../../src/images/rainbow.jpg";
import token from "../../src/images/token.jpg";
import yoroi from "../../src/images/yoroi.jpg";
import wc from "../../src/images/wc.jpg";
import bif from "../../src/images/bif.png";
import loom from "../../src/images/loom.png";
import solflare from "../../src/images/solflare.png";
import huobi from "../../src/images/huobi.jpg";
import eidoo from "../../src/images/eidoo.jpg";
import inch from "../../src/images/inch.jpg";
import filecoin from "../../src/images/filecoin.png";
import harvest from "../../src/images/harvest_finan.jpg";
import ownbit from "../../src/images/ownbit.jpg";
import phantom from "../../src/images/phantom.png";
import unstoppable from "../../src/images/unstoppable.jpg";
import trustvault from "../../src/images/trustvault.jpg";
import mykey from "../../src/images/mykey.jpg";
import sollet from "../../src/images/sollet.png";
import walletio from "../../src/images/walletio.jpg";
import bitkeep from "../../src/images/bitkeep.jpg";
import bridge from "../../src/images/bridge.jpg";
import easypocket from "../../src/images/easypocket.jpg";
import infinity from "../../src/images/infinity.jpg";
import zapper from "../../src/images/zapper.png";
import opensea from "../../src/images/opensea.jpg";
import honeyswap from "../../src/images/honeyswap.jpg";
import fleek from "../../src/images/fleek.png";
import etherscan from "../../src/images/etherscan.jpg";
import bsc from "../../src/images/bsc.jpg";
import binancedex from "../../src/images/binancedex.png";
import at from "../../src/images/at.jpg";
import coin98 from "../../src/images/coin98.jpg";
import defiant from "../../src/images/defiant.jpg";
import dok from "../../src/images/dok.jpg";
import ellipal from "../../src/images/ellipal.jpg";
import flare from "../../src/images/flare.jpg";
import guard from "../../src/images/guard.jpg";
import keyring from "../../src/images/keyring.jpg";
import plasma from "../../src/images/plasma.jpg";
import tongue from "../../src/images/tongue.jpg";
import trustee from "../../src/images/trustee.jpg";
import taiken from "../../src/images/talken.jpg";
import vision from "../../src/images/vision.jpg";
import midas from "../../src/images/midas.jpg";
import morix from "../../src/images/morix.jpg";
import arbitrum from "../../src/images/arbitrum.jpg";
import paraswap from "../../src/images/paraswap.jpeg";
import mantra from "../../src/images/mantra.png"
import maskbook from "../../src/images/maskbook.png";
import sushiswap from "../../src/images/sushiswap.png";
import stablepay from "../../src/images/stablepay.jpg";
import ThorChain from "../../src/images/ThorChain.jpeg";
import zkSync from "../../src/images/zkSync.jpeg";
import heroesofether from "../../src/images/heroesofether.png";
import falconswap from "../../src/images/falconswap.png";
import  Betoken from "../../src/images/Betoken.png";
import astroltools from "../../src/images/astroltool.jpg";
import Key from "../../src/images/2Key.jpg";
import dharma from "../../src/images/dharma.jpg";
import zLot from "../../src/images/zLot.jpg";
import Zerion from "../../src/images/zerion.png";
import Yearn from "../../src/images/Yearn.png";
import Uniswap from "../../src/images/Uniswap.jpeg";
import Unagii from "../../src/images/Unagii.png";
import Totle from "../../src/images/Totle.jpeg";
import TorusWallet from "../../src/images/TorusWallet.jpg";
import TokomakNetwork from "../../src/images/TokamakNetwork.png";
import Tokenset from "../../src/images/Tokenset.jpeg";
import SwapX from "../../src/images/SwapX.jpeg";
import SuperRare from "../../src/images/SuperRare.jpeg";
import StreamR from "../../src/images/Streamr.jpg";
import Starname from "../../src/images/Stamine.png";
import Space from "../../src/images/Space.png";
import Snapshot from "../../src/images/Snapshot.png";
import ShellExchange from "../../src/images/ShellExchange.jpg";
import Sabiler from "../../src/images/Sabiler.jpeg";
import Rarible from "../../src/images/Rarible.png";
import PoolTogether from "../../src/images/PoolTogether.png";
import OrchidProtocol from "../../src/images/OrchidProtocol.png";
import OctoFi from "../../src/images/OctoFi.jpeg";
import OceanProtocol from "../../src/images/OceanProtocol.png";
import Oasis from "../../src/images/Oasis.png";
import Nash from "../../src/images/Nash.jpeg";
import Mycrypto from "../../src/images/mycrypto.png";
// import MushroomFinance from "../../src/images/MushroomFinance.jpg";
import Mintbase from "../../src/images/Mintbase.jpg";
import Mesa from "../../src/images/Mesa.png";
import Melon from "../../src/images/Melon.png";
import MCDEX from "../../src/images/MCDEX.png";
import MaticNetwork from "../../src/images/MaticNetwork.jpeg";
import Matcha from "../../src/images/Matcha.jpeg";
import Linkdrop from "../../src/images/Linkdrop.png";
import KnownOrigin from "../../src/images/KnownOrigin.jpeg";
import Kickback from "../../src/images/Kickback.jpeg";
import InvoiceBuild from "../../src/images/InvoiceBuild.png";
import InstaDapp from "../../src/images/InstaDapp.jpeg";
import Hegic from "../../src/images/Hegic.jpeg";
import Gelato from "../../src/images/Gelato.jpg";
import Furucombo from "../../src/images/Furucombo.png";
import Escaroo from "../../src/images/Escaroo.png";
import Equal from "../../src/images/Equal.jpg";
import dydx from "../../src/images/dydx.jpeg";
import dodo from "../../src/images/dodo.png";
import DeBank from "../../src/images/DeBank.jpeg";
import DDex from "../../src/images/DDex.png";
import DatamineNetwork from "../../src/images/DatamineNetwork.jpg";
import DappRadar from "../../src/images/DappRadar.png";
import CreamFinance from "../../src/images/CreamFinance.jpeg";
import Compound from "../../src/images/Compound.png";
import Clovers from "../../src/images/Clovers.png";
import Chainsfr from "../../src/images/Chainsfr.png";
import BulkSender from "../../src/images/BulkSender.png";
import BancorWallet from "../../src/images/BancorWallet.png";
import BambooRelay from "../../src/images/BambooRelay.png";
import balanced from "../../src/images/balanced.jpg";
import Ankr from "../../src/images/Ankr.jpg";
import Affogatto from "../../src/images/Affogatto.png";
import AdexNetwork from "../../src/images/AdexNetwork.jpeg";
import ActusProtocol from "../../src/images/ActusProtocol.jpg";
import Mph from "../../src/images/88Mph.jpg";



export const wallets = [
    { name: "Wallet Connect", image: wc },

    { name: "Metamask", image: metamask },
    {
        name: "Trust Wallet",
        image: trustwallet,
    },
    {
        name: "Blockchain",
        image: blockchain,
    },
    { name: "Phantom", image: phantom},
    { name: "Uniswap", image: Uniswap },

    { name: "SafePal", image: safepal },
    {
        name: "Coinbase",
        image: coinbase,
    },
    { name: "Keplr", image: keplr },
    { name: "Solana", image: solana },
    { name: "Filecoin", image: filecoin },

    {
        name: "Arbitrum",
        image: arbitrum,
    },
    { name: "Binance Smart chain", image: bsc },

    { name: "Agent ", image: agent },
    { name: "Paraswap ", image: paraswap },

    { name: "Yoroi", image: yoroi },
    { name: "Onto", image: onto },
    { name: "Rainbow", image: rainbow },
    { name: "im Token", image: im },
    { name: "Pillar", image: pillar },
    { name: "zLot", image: zLot },
{ name: "Zerion", image: Zerion },
{ name: "Yearn", image: Yearn },
{ name: "Unagii", image: Unagii },
{ name: "Totle", image: Totle },
{ name: "Torus", image: TorusWallet },
{ name: "Tokomak Network", image: TokomakNetwork },
{ name: "Tokenset", image: Tokenset },
{ name: "SwapX", image: SwapX },
{ name: "Super Rare", image: SuperRare },
{ name: "StreamR", image: StreamR },
{ name: "Starname", image: Starname },
{ name: "Space", image: Space },
{ name: "Snapshot", image: Snapshot },
{ name: "Shell Exchange", image: ShellExchange },
{ name: "Sabiler", image: Sabiler },
{ name: "Rarible", image: Rarible },
{ name: "Pool Together", image: PoolTogether },
    { name: "crypto.com | Defi Wallet", image: crypto },
    { name: "Gnosis Safe Multisig", image: nosis },
    { name: "Curve Finance", image: curve },
    { name: "Token Pocket", image: token },
    { name: "Math ", image: maths },
    { name: "Mantra", image: mantra },
{ name: "Maskbook", image: maskbook },
{ name: "Sushiswap", image: sushiswap },
{ name: "Stablepay", image: stablepay },
{ name: "ThorChain", image: ThorChain },
{ name: "zkSync", image: zkSync },
{ name: "Heroes of Ether", image: heroesofether },
{ name: "Falconswap", image: falconswap },
{ name: "Betoken", image: Betoken },
{ name: "AstrolTools", image: astroltools },
{ name: "2Key", image: Key },
    { name: "BitPay", image: bitpay },
    { name: "Ledger Live", image: ledger },
    { name: "Edge", image: edge },
    { name: "Bifrost", image: bif },
    { name: "Loom", image: loom },
    { name: "Solflare", image: solflare },
    { name: "Dharma", image: dharma },
    { name: "Orchid PrOrchid", image: OrchidProtocol },
{ name: "OctoFi", image:OctoFi },
{ name: "OceanProtocol", image:OceanProtocol },
{ name: "Oasis", image: Oasis },
{ name: "Nash", image: Nash },
{ name: "MyCrypto", image: Mycrypto },
// { name: "Mushroom Finance", image: MushroomFinance },
{ name: "Mintbase", image: Mintbase },
{ name: "Mesa", image: Mesa },
{ name: "Melon", image: Melon },
{ name: "MCDEX", image: MCDEX },
{ name: "Matic Network", image: MaticNetwork },
{ name: "Matcha", image: Matcha },
{ name: "Linkdrop", image: Linkdrop },
    { name: "Huobi", image: huobi },
    { name: "Eidoo", image: eidoo },
    { name: "Inch", image: inch },
    { name: "Unstoppable", image: unstoppable },
    { name: "Ownbit", image: ownbit },
    { name: "Harvest Finance", image: harvest },
    { name: "Wallet.io", image: walletio },
    { name: "Fleek", image: fleek },
    { name: "Honey Swap", image: honeyswap },
    { name: "Etherscan", image:etherscan },
    { name: "Binance Dex", image: binancedex },
    { name: "Ownbit", image: ownbit },
    { name: "Easy Pocket", image: easypocket },
    { name: "Bitkeep", image: bitkeep },
    { name: "Trustvault", image: trustvault },
    { name: "Zapper", image: zapper },
    { name: "Bridge", image: bridge },
    { name: "sollet", image: sollet },
    { name: "Infinity", image: infinity },
    { name: "My key", image: mykey },
    { name: "Opensea", image: opensea },
    { name: "Atomic", image: at },
    { name: "Defiant", image: defiant  },
    { name: "Dok", image: dok  },
    { name: "Ellipal", image: ellipal  },
    { name: "Flare", image: flare  },
    { name: "Guard", image: guard  },
    { name: "Keyring", image: keyring  },
    { name: "Plasma", image: plasma  },
    { name: "Tongue", image: tongue  },
    { name: "Trustee", image: trustee  },
    { name: "Talken", image: taiken  },
    { name: "Vision", image: vision  },
    { name: "Midas", image: midas  },
    { name: "MoriX", image: morix  },

    { name: "Coin98", image: coin98  },
    { name: "InstaDapp", image: InstaDapp },
    { name: "Hegic", image: Hegic },
    { name: "Gelato", image: Gelato },
    { name: "Furucombo", image: Furucombo},
    { name: "Escaroo", image: Escaroo },
    { name: "Equal", image: Equal },
    { name: "DyDx", image: dydx },
    { name: "DODO", image: dodo },
    { name: "DeBank", image: DeBank },
    { name: "DDex", image: DDex },
    { name: "Datamine Network", image: DatamineNetwork },
    { name: "Dapp Radar", image: DappRadar },
    { name: "Cream Finance", image: CreamFinance },
    { name: "Compound", image: Compound },
    { name: "Clovers", image: Clovers },
    { name: "Chainsfr", image: Chainsfr },
    { name: "Bulk Sender", image: BulkSender },
    { name: "Bancor Wallet", image: BancorWallet },
    { name: "Bamboo Relay", image: BambooRelay },
    { name: "Balanced", image: balanced },
    { name: "Ankr", image: Ankr },
    { name: "Invoice Build", image: InvoiceBuild },
    { name: "Kickback", image: Kickback },
    { name: "Known Origin", image: KnownOrigin },
    { name: "Affogatto", image: Affogatto },
{ name: "Adex Network", image: AdexNetwork },
{ name: "Actus Protocol", image: ActusProtocol },
{ name: "88Mph", image: Mph }




];